import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, switchMap } from 'rxjs';

import * as UserContextSettingsActions from './user-context-settings.actions';

@Injectable()
export class UserContextSettingsEffects {
  private actions$ = inject(Actions);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserContextSettingsActions.initUserContextSettings),
      switchMap(() =>
        of(
          UserContextSettingsActions.loadUserContextSettingsSuccess({
            userContextSettings: [],
          })
        )
      ),
      catchError((error) => {
        return of(
          UserContextSettingsActions.loadUserContextSettingsFailure({ error })
        );
      })
    )
  );
}
